import { mergePlain } from 'util/merge'
import { doBulkUpdate } from './doBulkUpdate'
import { doDelete } from './doDelete'

export const doBulkDelete = (ticketIds, options = {}) => dispatch => {
  return dispatch(
    doBulkUpdate(
      ticketIds,
      doDelete,
      [],
      mergePlain(
        {
          moduleOptions: {
            snackbar: {
              enabled: true,
              success: {
                enabled: true,
                message: `${app.t('N_Tickets', {
                  count: ticketIds.length,
                })} deleted forever`,
              },
              failed: {
                enabled: false,
              },
            },
          },
        },
        options
      )
    )
  )
}
